
import { updateDiagramNodeLabelFontSize, getDiagramNodeLabelFontSize } from '@process-advisor/process-miner/processMiner/processMiner';

export type NodeLabelFontSizeProps = {
    font_size?: string;
}

export const changeNodeLabelFontSize = ({ font_size }: NodeLabelFontSizeProps) => {
    updateDiagramNodeLabelFontSize({ font_size });
}

export const getNodeLabelFontSize = () => getDiagramNodeLabelFontSize();
